import cn from "clsx";
import { useEffect } from "react";
import { loadScript } from "design-system/hooks/use-script";
import "./active-campaign-embed.scss";

export interface ActiveCampaignEmbedProps {
  embedSourceUrl: string;
}

export function ActiveCampaignEmbed({
  embedSourceUrl,
}: ActiveCampaignEmbedProps) {
  const wrapperClass = cn(
    `hbs-global-align-center`,
    "hbs-component--active-campaign-form-embed",
  );

  // Extract the form ID using regex
  const formIdMatch = embedSourceUrl.match(/\/f\/(\d+)/);
  const extractedFormId = formIdMatch ? formIdMatch[1] : null;

  useEffect(() => {
    if (extractedFormId) {
      loadScript(
        `https://hbs671.activehosted.com/f/embed.php?id=${extractedFormId}`,
        {
          defer: true,
        },
      );
    } else {
      console.warn("Form ID not found in the URL");
    }
  }, [extractedFormId]);

  return (
    <div className={wrapperClass} data-region="cb__active-campaign-form-embed">
      <div className="hbs-active-campaign-form-embed">
        <div
          className={`_form_${extractedFormId}`}
          // We need this id for css specificity to override active campaign styles,
          // but it might cause issues if this component is used multiple times on the same page
          id="hbs-active-campaign-form-embed"
        />
      </div>
    </div>
  );
}
